
class KlaviyoNotifyPopupGridItem extends HTMLElement {
  constructor() {
    super();
  }
  open() {
    this.classList.add("active");
  }
  close() {
    this.classList.remove("active");
  }
  successCallback(result) {
    const content = this.querySelector(".klaviyo-content");
    const success = this.querySelector(".klaviyo-success");
    content.classList.add("hidden");
    success.classList.remove("hidden");
  }
  errorCallback(error) {
    const content = this.querySelector(".klaviyo-content");
    const error_display = this.querySelector(".klaviyo-error");
    content.classList.add("hidden");
    error_display.classList.remove("hidden");
  }
  submit(email, variant) {
    const that = this;
    const payload = {
      data: {
        type: "back-in-stock-subscription",
        attributes: {
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: `${email}`,
              },
            },
          },
          channels: ["EMAIL"],
        },
        relationships: {
          variant: {
            data: {
              type: "catalog-variant",
              id: `$shopify:::$default:::${variant}`,
            },
          },
        },
      },
    };
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        revision: "2024-06-15",
      },
      body: JSON.stringify(payload),
    };
    fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=QY7fZS", options)
      .then((result) => that.successCallback(result))
      .catch((error) => that.errorCallback(error));
  }
  connectedCallback() {
    this.variantId = !!this.getAttribute("variant") ? this.getAttribute("variant") : null;
    this.emailInput = this.querySelector("#klaviyo-email-input");
    this.submitButton = this.querySelector(".klaviyo-email-submit");
    this.closeButton = this.querySelector(".klaviyo-close");
    this.content = this.querySelector(".klaviyo-popup-card");
    this.addEventListener("click", (event) => {
      if (!this.content.contains(event.target)) {
        this.close();
      }
    });
    if (!!this.closeButton) {
      this.closeButton.addEventListener("click", (event) => {
        this.close();
      });
    }
    if (!!this.emailInput && !!this.submitButton && !!this.variantId) {
      this.submitButton.addEventListener("click", (event) => {
        if (this.emailInput.validity.valid) {
          const email = this.emailInput.value;
          const variant = this.variantId;
          if (!!email) {
            this.submit(email, variant);
          }
        } else {
          alert("Email invalid");
        }
      });
    }
  }
}
customElements.define("klaviyo-notify-popup-grid-item", KlaviyoNotifyPopupGridItem);

class KlaviyoNotifyButtonGridItem extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const popup_id = !!this.getAttribute("for") ? this.getAttribute("for") : null;
    this.popup = document.querySelector(`#${popup_id}`);
    this.addEventListener("click", (event) => {
      this.popup.open(); 
    });
  }
}
customElements.define("klaviyo-notify-button-grid-item", KlaviyoNotifyButtonGridItem);